import { ShoppingBag } from "lucide-react";

import type { BundleOnsiteUpsellComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const BundleOnsiteUpsellComponentListItem = ({
  mod,
}: {
  mod: BundleOnsiteUpsellComponent;
}) => {
  const subtitle =
    mod.description ||
    (mod.location === "cart" ? "Cart bundle" : "Product page bundle");
  return (
    <ModificationListItem
      mod={mod}
      icon={<ShoppingBag size={16} />}
      title="Bundle upsell"
      subtitle={subtitle}
    />
  );
};
